//基础配置
import configBase from '@/config/config_base.js'
// 默认
import configDefault from '@/config/oem/config_default.js'

//是否初始化（默认为false）
let isInit = false;

import oemConfigMap from '@/config/oem_config_map.js'
let config = {
  //平台课程是否免费
  freeCourse: false,
  images: {
    base: {}
  },
  oemPages: {

  },
  /**
   * 初始化加载 config (根据域名进行初始化)
   */
  initConfig(hostName) {
    if (isInit) {
       return ;
    }
    // 根据当前访问的域名获取oem配置，如果没有oem配置就走默认的配置
    let oemConfig = oemConfigMap.get(hostName);
    if (oemConfig) {
      this.copyToThen(oemConfig);
    } else {
      this.copyToThen(configDefault);
    }
    // 基础图片
    this.images.base = configBase.images.base;

    if (!this.files.helpFile) {
      this.files.helpFile = configBase.files.helpFile;
    }
    if (!this.files.studentHandbook) {
      this.files.studentHandbook=configBase.files.studentHandbook;

    }
    if (!this.files.managementManual) {
      this.files.managementManual=configBase.files.managementManual;
    }
    if (!this.files.emergencyManual) {
      this.files.emergencyManual=configBase.files.emergencyManual;
    }

    if (!this.files.template) {
      this.files.template = configBase.files.template;
    }
    document.title = this.platformName;
    document.getElementById('favicon').href = this.images.logoImage;
    //初始化标记
    isInit = true;
  },
  copyToThen(cfg) {
    for (let key  in cfg) {
      this[key] =  cfg[key];
    }
  }
}
export default config



// WEBPACK FOOTER //
// ./src/config/config.js